import { Draft, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DrawerSize, DrawerState } from 'models';

const initialState: DrawerState = {
  drawerVisibility: 'closed',
  invisible: false,
  drawerSize: 'medium'
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setDrawerOpen: (state: Draft<DrawerState>, payloadAction: PayloadAction<'closed' | 'open' | 'minimized'>) => {
      state.drawerVisibility = payloadAction.payload;
    },
    setDrawerSize: (state: Draft<DrawerState>, payloadAction: PayloadAction<DrawerSize>) => {
      state.drawerSize = payloadAction.payload;
    },
    setDrawerInvisible: (state: Draft<DrawerState>, payloadAction: PayloadAction<boolean>) => {
      state.invisible = payloadAction.payload;
    }
  }
});

export const { setDrawerOpen, setDrawerSize, setDrawerInvisible } = drawerSlice.actions;

export default drawerSlice.reducer;
